import { render, staticRenderFns } from "./EventManagementLogs.vue?vue&type=template&id=f123e9f8&scoped=true&"
import script from "./EventManagementLogs.vue?vue&type=script&lang=js&"
export * from "./EventManagementLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f123e9f8",
  null
  
)

export default component.exports